import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { colors, radii, shadows } from '../../styles/tokens';

export interface ResultCardProps {
  label?: string;
  value?: React.ReactNode;
  caption?: string;
  actions?: React.ReactNode;
  children?: React.ReactNode;
}

export const ResultCard: React.FC<ResultCardProps> = ({
  label,
  value,
  caption,
  actions,
  children,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        bgcolor: colors.paper,
        border: `1px solid ${colors.border}`,
        borderRadius: `${radii.card}px`,
        boxShadow: shadows.resting,
        p: 3,
        width: '100%',
      }}
    >
      {(label || actions) && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1.5,
            mb: value !== undefined ? 1 : 2,
          }}
        >
          {label && (
            <Typography
              variant="overline"
              sx={{ color: colors.textSecondary, fontWeight: 600, letterSpacing: '0.06em' }}
            >
              {label}
            </Typography>
          )}
          {actions && <Box sx={{ flexShrink: 0 }}>{actions}</Box>}
        </Box>
      )}
      {value !== undefined && (
        <Typography
          variant="h4"
          component="p"
          sx={{ fontWeight: 700, color: colors.textPrimary, lineHeight: 1.2 }}
        >
          {value}
        </Typography>
      )}
      {caption && (
        <Typography variant="body2" sx={{ color: colors.textSecondary, mt: 1 }}>
          {caption}
        </Typography>
      )}
      {children && <Box sx={{ mt: value !== undefined || label ? 2 : 0 }}>{children}</Box>}
    </Paper>
  );
};
